import React from 'react';
import { Button } from '../../../ui-kit';





const FooterButtons = (props) => {
  const { onClickHelpLink } = props;
  return (
    <>
      <Button type="TERTIARY" onClick={onClickHelpLink}>Learn More</Button>
      <Button
        id="nav-item-livesupport"
        className="topup-modal__button"
        type="PRIMARY">

        Live Chat Now
      </Button>
    </>);

};

export default FooterButtons;